import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ReactComponent as WarningIcon } from '../../../../../assets/images/warningIcon.svg';
import Button from '../../../../../components/shared/Button/Button';
import Modal from '../../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from './ImportResultModal.module.scss';

const ImportResultModal = ({ showModal, toggleModal, valid, invalid, total }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  return (
    <Modal
      show={showModal}
      onHide={toggleModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('csvImport.invalidEmail')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.content}>
          <WarningIcon />
          <p className={styles.text}>
            <span className={styles.bold}>
              <u>{valid}</u>
            </span>
            &nbsp;{t('csvImport.ofContactsAdded', { total })}
          </p>
          <p className={classNames(styles.text, styles.info)}>
            <span className={styles.bold}>{invalid}</span> {t('csvImport.invalidRecords')}
          </p>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <div className={styles.btnsCont}>
          <Button variant="primary" onClick={toggleModal} className={styles.btn}>
            {t('ok')}
          </Button>
        </div>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default ImportResultModal;
